import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Transition from 'semantic-ui-react/dist/es/modules/Transition';
import 'semantic-ui-css/components/transition.min.css';
import WelcomeTooltip from './WelcomeTooltip/WelcomeTooltip';
import './Welcome.css';
import { WelcomeSplash, Button } from 'web-store-modules/packages/web-store-ui-library/'
import { getWelcomeExploreUrlAsync } from '../../../utils/StaticAssetManager.js';
import { getWelcomeMessageStyleAsync, getWelcomeTitleAsync, getStyleColorAsync, singaporeStoreId } from '../../../utils/StoreConfigManager.js';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { storeId } from '../../../../../variables/Variables';

const defaultFontFamily = 'sans-serif';

const isMobile = isMobileDevice();
const logo = 'https://cdn.obsess-vr.com/fendi/Fendi_logo_White.png';
const welcomeShowTime = 5000;
const WelcomeTooltipShowTime = 10000;

class Welcome extends Component {
    constructor(props) {
        super(props);
        this.hide = this.hide.bind(this);
        this.onHide = this.onHide.bind(this);

        this.state = {
            text: '',
            imageSrc: '',
            visible: true,
            welcomeMessageStyle: null,
            pendingLoadAssetCount: 3,
            primaryColor: '',
            secondaryColor: '',
             visibleTooltip: false,
            showWelTooltip: true,
            showBroseTooltip: false,
            showProductTooltip: false,
            showBeautyTooltip: false,
            showOverlay: true
        };

        this.timeOutFunction = null;
        this.timeOutBrowseFunc = null;
        this.timeOutProductFunc = null;
        this.timeOutBeautyFunc = null;
    }

    componentDidMount() {
        getWelcomeMessageStyleAsync()
            .then(style => {
                if (style) {
                    const welcomeMessageStyle = {
                        fontFamily: style.name + ',' + defaultFontFamily
                    };
                    if (!isMobile) {
                        welcomeMessageStyle.fontSize = style.size;
                    }
                    this.setState(state => {
                        return {
                            welcomeMessageStyle: welcomeMessageStyle,
                            pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                        };
                    });
                }
            })
            .catch(error => console.error(error));

        getStyleColorAsync()
            .then(style => {
                const primaryColor = style[0];
                const secondaryColor = style[1];
                this.setState({ primaryColor, secondaryColor })
            })
            .catch(error => console.error(error));

        getWelcomeTitleAsync()
            .then(welcomeText => {
                this.setState(state => {
                    return {
                        text: welcomeText,
                        pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                    };
                });
            })
            .catch(error => console.error(error));

        getWelcomeExploreUrlAsync()
            .then(url => {
                const welcomeImage = new Image();
                welcomeImage.onload = () => {
                    this.setState(state => {
                        return {
                            pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                        };
                    });
                }
                welcomeImage.src = url;
                this.setState({ imageSrc: url })
            })
            .catch(error => console.error(error));

        
        let removeConsentInterval = false;

        const getCookie = (name) => {
            let cookie = {};
            document.cookie.split(';').forEach(function(el) {
                let [k,v] = el.split('=');
                cookie[k.trim()] = v;
            })
            return cookie[name];
            }

        const checkForConsent = () => {
            const consentCookieCheck = getCookie('OptanonAlertBoxClosed');
            return consentCookieCheck;
        }

        const welcomeConsentDelay = setInterval(() => {
            const consent = checkForConsent();
            if (removeConsentInterval) return;
            if (consent) {
                removeConsentInterval = true;
                setTimeout(() => {
                    this.hide();
                }, welcomeShowTime);
            }
        }, 1000)

        setTimeout(()=>clearInterval(welcomeConsentDelay), 30000)
            
    }

    componentWillUnmount() {
        if (isMobile) {
            window.removeEventListener('touchend', this.hide);
        } else {
            window.removeEventListener('click', this.hide);
        }
        clearTimeout(this.timeOutProductFunc);
        clearTimeout(this.timeOutBeautyFunc);
        clearTimeout(this.timeOutBrowseFunc);
        if (this.timeOutFunction) {
            clearTimeout(this.timeOutFunction);
        }
    }

    hide() {
        this.setState({ visible: false });
    }

    onHide() {
        this.props.onWelcomeHide();
    }

    getUpdatedWelcomeMessageStyle() {
        const { isFlatImageScene } = this.props;
        const { welcomeMessageStyle } = this.state;
        const updatedWelcomeMessageStyle = { ...welcomeMessageStyle, fontSize: 30 };

        return isFlatImageScene ? updatedWelcomeMessageStyle : {...welcomeMessageStyle,fontSize:'30px'};
    }

    onShowTooltip = () => {
        if (this.state.showWelTooltip) {
            this.timeOutBrowseFunc = setTimeout(
                () => this.setState({ showWelTooltip: false, showBroseTooltip: true, visibleTooltip: true,showOverlay:true }),
                100
            );

            this.timeOutProductFunc = setTimeout(() =>
                this.setState({ showProductTooltip: true }), 100);
            this.timeOutBeautyFunc = setTimeout(() =>
                this.setState({ showBeautyTooltip: true }), 100);

            // setTimeout(() => {
            //     this.setState({ visibleTooltip: false, showOverlay: false});
            //     this.props.onWelcomeHide();
            // }, WelcomeTooltipShowTime);
        }
    }

    render() {
        const { showingUI, isFlatImageScene, flatImageButtonOption, flatImageButtonText } = this.props;
        const { text, visible, pendingLoadAssetCount, primaryColor, secondaryColor,welcomeFadeout, showBroseTooltip, showProductTooltip, showBeautyTooltip, visibleTooltip, showOverlay} = this.state;

        if (!showingUI || pendingLoadAssetCount > 0) {
            return <React.Fragment />;
        }
        if (!this.timeOutFunction) {
            this.setState({ welcomeFadeout: 'welcome-fadeout' });
            this.onShowTooltip();

            this.timeOutFunction = setTimeout(() => {
                this.hide();
            }, welcomeShowTime);
        }

        return (
            <div id={showOverlay ? 'welcome-overlay' : ''} className={welcomeFadeout} onClick={this.hide}>
               <div className='welcome-header'>
                    {storeId === singaporeStoreId && <div className="welcome-logo">
                        <img src={logo} alt="welcome-gif" />
                    </div>}
                    <Transition
                        visible={visible}
                        animation='fade'
                        duration={300}
                        onHide={this.onHide}
                    >
                        <WelcomeSplash
                            welcomeMessageStyle={this.getUpdatedWelcomeMessageStyle()}
                            welcomeText={text}
                            hideTooltip={storeId === singaporeStoreId ? true : flatImageButtonOption}
                        >
                            {
                                flatImageButtonOption &&
                                <Button
                                    style={{ ...this.getUpdatedWelcomeMessageStyle(), padding: '0.2em 1em', marginTop: '0.5em' }}
                                    primaryColor={primaryColor}
                                    secondaryColor={secondaryColor}
                                >
                                    <p id='flat-image-button-text'>{flatImageButtonText}</p>
                                </Button>
                            }
                        </WelcomeSplash>
                    </Transition>
                </div> 
                {storeId === singaporeStoreId && visibleTooltip  && 
                <Transition
                    visible={visibleTooltip}
                    animation='fade'
                    duration={500}
                >
                    <WelcomeTooltip 
                        welcomeMessageStyle={this.getUpdatedWelcomeMessageStyle()}
                        showBroseTooltip={showBroseTooltip}
                        showBeautyTooltip={showBeautyTooltip}
                        showProductTooltip={showProductTooltip}
                        isVisible={visibleTooltip}
                        onWelcomeHide={this.props.onWelcomeHide}
                        isMobile={isMobile} 
                        storeId={storeId}
                    >
                    </WelcomeTooltip>
                </Transition>
                }
            </div>
        );
    }
}

Welcome.propTypes = {
    showingUI: PropTypes.bool,
    onWelcomeHide: PropTypes.func,
    isFlatImageScene: PropTypes.bool,
    flatImageButtonOption: PropTypes.bool,
    flatImageButtonText: PropTypes.string,
};

export default Welcome;
